import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=81e599ba&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/footerPage.scss?vue&type=style&index=0&id=81e599ba&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e599ba",
  null
  
)

export default component.exports